module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    attrs: {
      "id": "app"
    }
  }, [(_vm.$store.state.core.loading) ? _c('div', {
    staticClass: "preloader"
  }, [_c('svg', {
    staticClass: "spinner",
    attrs: {
      "viewBox": "0 0 50 50"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "25",
      "cy": "25",
      "r": "20",
      "fill": "none",
      "stroke-width": "5"
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.core.loading && _vm.$store.state.core.user && !_vm.$store.state.core.user.firstLogin) ? _c('app-header') : _vm._e(), _vm._v(" "), (!_vm.$store.state.core.loading && _vm.$store.state.core.user && !_vm.$store.state.core.user.firstLogin) ? _c('side-menu', {
    staticClass: "side-menu"
  }) : _vm._e(), _vm._v(" "), (!_vm.$store.state.core.loading) ? _c('router-view', {
    on: {
      "loading": _vm.toggleLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-597a1e74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CORE/App.vue
// module id = 517
// module chunks = 1